import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledRelationDetailsPage = styled.div`
    display: flow-root;
    width: 100%;
    .userNameTitle {
        margin-bottom: 30px;
        font-size: var(--size-20);
        font-weight: bold;
        line-height: 30px;
        color: var(--color-primary);
        text-transform: uppercase;
        @media ${breakpoints.xs} {
            font-size: var(--size-18);
            line-height: 25px;
        }
    }
    .infoBox {
        margin-bottom: 20px;
    }
    .formPanel {
        .infoContainer {
            .label {
                min-width: 210px;
                @media ${breakpoints.sm} {
                    min-width: 165px;
                    margin-right: 10px;
                }
            }
        }
    }

    .row {
        display: flex;
        @media ${breakpoints.xs} {
            display: block;
        }
        .col {
            width: 50%;
            @media ${breakpoints.xs} {
                width: 100%;
            }
            &:first-child {
                margin-right: 6%;
                @media ${breakpoints.sm} {
                    margin-right: 1.5%;
                }
            }
        }
    }
`;
